import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Sankey chart type
 * Extends the base chart configuration
 * Requires the highcharts-sankey module
 */
export const sankeyChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'sankey'
    },
    title: {
        text: undefined
    },
    plotOptions: {
        sankey: {
            dataLabels: {
                enabled: true,
                format: '{point.name}',
                style: {
                    fontSize: '0.9em',
                    textOutline: 'none'
                }
            },
            states: {
                hover: {
                    color: '#a4edba'
                }
            },
            tooltip: {
                nodeFormat: '{point.name}: <b>{point.sum}</b><br/>'
            },
            // Curvature of the links
            curveFactor: 0.33,
            // Node width
            nodeWidth: 20,
            // Node padding
            nodePadding: 10
        }
    },
    tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.fromNode.name}</b> → <b>{point.toNode.name}</b>: <b>{point.weight}</b><br/>',
        nodeFormatter: function () {
            // 'this' refers to the node
            return ''; //'<b>' + this.name + '</b>: <b>' + this.sum + '</b><br/>';
        }
    },
    // For sankey charts, we typically don't need axes
    xAxis: {
        visible: false
    },
    yAxis: {
        visible: false
    }
} as Options);
